const hasPaymentPlanInstallments = (paymentPlanInstallments = -1): boolean => {
  return paymentPlanInstallments > 1;
};

export default hasPaymentPlanInstallments;
